'use strict';
/*
  kraft — paper-collage / zine. Every word is a torn off-white paper cut-out,
  slightly rotated (deterministic per word) with a soft drop shadow, ink text on
  top; the key word lands on a red paper scrap with white ink. Warm kraft grain
  backdrop in music/photos, the cut-outs carry it over talking-head footage.
*/
const { FONTS, roundRect } = require('../lib/draw');
const { layoutCue } = require('./_common');

const palette = { bg: '#c2a878', fg: '#1c150c', accent: '#cf3b27', ink: '#1c150c', paper: '#f3ead6' };
const PAPERS = ['#f3ead6', '#efe2c4', '#e9dabb', '#f5efde'];
function hash(s){ let h = 2166136261; for (let i = 0; i < s.length; i++){ h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }

function init(st){ st.s.font = st.tk.registerFamily('ForgeKraft', FONTS.arialBlack) || undefined; }

function background(ctx, st){
  const { W, H } = st, tk = st.tk;
  if (!st.overlayMode) {
    const g = ctx.createLinearGradient(0, 0, W, H);
    g.addColorStop(0, '#cdb487'); g.addColorStop(0.5, '#c2a878'); g.addColorStop(1, '#b39866');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    ctx.save(); ctx.globalAlpha = 0.06; ctx.globalCompositeOperation = 'multiply'; ctx.drawImage(tk.grain(), -Math.random() * 80, -Math.random() * 80); ctx.restore();
    // a couple of darker fibre smudges
    ctx.save(); ctx.globalAlpha = 0.05; ctx.fillStyle = '#5a4327';
    for (let i = 0; i < 5; i++){ const x = st.rnd() * W, y = st.rnd() * H, r = 60 + st.rnd() * 180; ctx.beginPath(); ctx.arc(x, y, r, 0, 7); ctx.fill(); }
    ctx.restore();
  }
}

function paintToken(ctx, o){
  const { T, cx, cy, px, scl, alpha, emph, st, ghost, tw } = o, tk = st.tk;
  const h = hash(T), ang = (((h % 1000) / 1000) - 0.5) * 0.14;
  ctx.save(); ctx.globalAlpha = alpha; ctx.translate(cx, cy); ctx.rotate(ang); ctx.scale(scl, scl);
  ctx.font = tk.font(px, 900, st.s.font); ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  if (ghost) { ctx.fillStyle = 'rgba(40,30,15,0.4)'; ctx.fillText(T, 0, 0); ctx.restore(); return; }
  const w = (tw || ctx.measureText(T).width) / 2, padX = px * 0.20;
  const top = -px * 0.5 - px * 0.14, ht = px * 0.92 + px * 0.28;
  ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.32)'; ctx.shadowBlur = px * 0.12; ctx.shadowOffsetX = px * 0.02; ctx.shadowOffsetY = px * 0.05;
  ctx.fillStyle = emph ? palette.accent : PAPERS[h % PAPERS.length];
  roundRect(ctx, -w - padX, top, (w + padX) * 2, ht, px * 0.05); ctx.fill();
  ctx.restore();
  // a torn highlight edge along the top of the scrap
  ctx.globalAlpha = alpha * 0.4; ctx.fillStyle = emph ? '#e86552' : '#ffffff';
  ctx.fillRect(-w - padX, top, (w + padX) * 2, px * 0.03); ctx.globalAlpha = alpha;
  ctx.fillStyle = emph ? '#fdf4e6' : palette.ink; ctx.fillText(T, 0, 0);
  ctx.restore();
}

function drawCue(ctx, st){
  const anchor = st.mode === 'talk' ? 0.74 : 'center';
  layoutCue(ctx, st, { sizes: { big: 138, mid: 112, small: 62 }, anchor, safeW: 0.84, reveal: 0.28, stagger: 0.06, trans: 0.2, family: st.s.font, paintToken });
}

function overlay(ctx, st){
  const tk = st.tk;
  ctx.drawImage(tk.vignette(st.overlayMode ? 0.34 : 0.52, 360), 0, 0);
  if (!st.overlayMode) { ctx.fillStyle = palette.accent; ctx.fillRect(0, st.H - 6, st.W * st.progress, 6); }
}

module.exports = { id: 'kraft', label: 'Collage · torn paper', palette, init, background, drawCue, overlay, paintToken };
